import { render, staticRenderFns } from "./PageVideo.vue?vue&type=template&id=559f01ce&scoped=true&"
import script from "./PageVideo.vue?vue&type=script&lang=js&"
export * from "./PageVideo.vue?vue&type=script&lang=js&"
import style1 from "./PageVideo.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559f01ce",
  null
  
)

export default component.exports